// Static i18n for Evony Strategist (Phase 6). No LLM calls; hardcoded dictionaries.
export const LANGUAGES = [
  { code: "en", label: "English", native: "English", dir: "ltr" },
  { code: "fr", label: "Français", native: "Français", dir: "ltr" },
  { code: "ja", label: "日本語", native: "日本語", dir: "ltr" },
  { code: "de", label: "Deutsch", native: "Deutsch", dir: "ltr" },
  { code: "es", label: "Español", native: "Español", dir: "ltr" },
  { code: "ko", label: "한국어", native: "한국어", dir: "ltr" },
  { code: "ar", label: "العربية", native: "العربية", dir: "rtl" },
  { code: "pt", label: "Português", native: "Português", dir: "ltr" },
];

export const RTL_LANGS = ["ar"];

const SUGGESTIONS = {
  en: [
    { topic: "Generals", q: "What are the best mounted PvP generals?" },
    { topic: "Bosses", q: "What is the power of bosses in Evony?" },
    { topic: "Equipment", q: "What equipment gives the best attack buffs?" },
    { topic: "Research", q: "What does the Academy do and what research is important?" },
    { topic: "Dragons", q: "How do I use dragons in Evony?" },
  ],
  fr: [
    { topic: "Généraux", q: "Quels sont les meilleurs généraux montés en PvP ?" },
    { topic: "Boss", q: "Quelle est la puissance des boss dans Evony ?" },
    { topic: "Équipement", q: "Quel équipement offre les meilleurs bonus d'attaque ?" },
    { topic: "Recherche", q: "À quoi sert l'Académie et quelles recherches sont importantes ?" },
    { topic: "Dragons", q: "Comment utiliser les dragons dans Evony ?" },
  ],
  ja: [
    { topic: "将軍", q: "PvPで最強の騎兵将軍は？" },
    { topic: "ボス", q: "Evonyのボスのパワーはどれくらい？" },
    { topic: "装備", q: "攻撃バフが最も高い装備は？" },
    { topic: "研究", q: "アカデミーの役割と重要な研究は？" },
    { topic: "ドラゴン", q: "ドラゴンの使い方は？" },
  ],
  de: [
    { topic: "Generäle", q: "Was sind die besten berittenen PvP-Generäle?" },
    { topic: "Bosse", q: "Wie stark sind die Bosse in Evony?" },
    { topic: "Ausrüstung", q: "Welche Ausrüstung gibt die besten Angriffsboni?" },
    { topic: "Forschung", q: "Was macht die Akademie und welche Forschung ist wichtig?" },
    { topic: "Drachen", q: "Wie benutze ich Drachen in Evony?" },
  ],
  es: [
    { topic: "Generales", q: "¿Cuáles son los mejores generales montados para PvP?" },
    { topic: "Jefes", q: "¿Cuánto poder tienen los jefes en Evony?" },
    { topic: "Equipo", q: "¿Qué equipo da los mejores bonos de ataque?" },
    { topic: "Investigación", q: "¿Qué hace la Academia y qué investigación es importante?" },
    { topic: "Dragones", q: "¿Cómo se usan los dragones en Evony?" },
  ],
  ko: [
    { topic: "장군", q: "PvP 최고의 기병 장군은?" },
    { topic: "보스", q: "Evony 보스의 전투력은 얼마나 되나요?" },
    { topic: "장비", q: "공격 버프가 가장 좋은 장비는?" },
    { topic: "연구", q: "아카데미의 역할과 중요한 연구는?" },
    { topic: "드래곤", q: "드래곤은 어떻게 사용하나요?" },
  ],
  ar: [
    { topic: "الجنرالات", q: "ما هي أفضل جنرالات الفرسان في PvP؟" },
    { topic: "الوحوش", q: "ما مقدار قوة الوحوش في Evony؟" },
    { topic: "المعدات", q: "ما المعدات التي تمنح أفضل تعزيزات الهجوم؟" },
    { topic: "البحث", q: "ما دور الأكاديمية وما البحوث المهمة؟" },
    { topic: "التنانين", q: "كيف أستخدم التنانين في Evony؟" },
  ],
  pt: [
    { topic: "Generais", q: "Quais são os melhores generais montados para PvP?" },
    { topic: "Chefes", q: "Qual é o poder dos chefes no Evony?" },
    { topic: "Equipamento", q: "Qual equipamento dá os melhores bônus de ataque?" },
    { topic: "Pesquisa", q: "O que a Academia faz e qual pesquisa é importante?" },
    { topic: "Dragões", q: "Como usar dragões no Evony?" },
  ],
};

const STR = {
  en: {
    "nav.strategist": "AI Strategist", "nav.generals": "Generals", "nav.monsters": "Monsters",
    "nav.guides": "Guides", "nav.language": "Language",
    "brand.tagline": "Your AI strategy companion for Evony",
    "brand.unofficial": "Unofficial companion for Evony: The King's Return",
    "chat.intro": "Ask an Evony question, or tap a starter below:",
    "chat.placeholder": "Ask about Evony…", "chat.searching": "Searching the Evony Guide Wiki…",
    "chat.sources": "Sources", "chat.copy": "Copy", "chat.copied": "Copied",
    "chat.noReliableSource": "no reliable source", "chat.error": "Error",
    "generals.title": "Evony Generals", "generals.subtitle": "Search generals and see the guides they appear in, sourced from the Evony Guide Wiki.",
    "generals.search": "Search a general by name…",
    "monsters.title": "Evony Monsters & Bosses", "monsters.subtitle": "Browse bosses and monsters with power values sourced from the Evony Guide Wiki.",
    "monsters.search": "Search a monster or boss…", "monsters.power": "Power", "monsters.level": "Level", "monsters.type": "Type",
    "guides.title": "Evony Guides", "guides.subtitle": "Discover strategy guides for generals, bosses, research and more, in your language.",
    "guides.search": "Search guides…", "guides.allCategories": "All categories",
    "guides.availableIn": "Available in", "guides.contents": "In this guide", "guides.openWiki": "Open on Evony Guide Wiki",
    "guides.contentNote": "This is a discovery summary. Open the original Wiki page for the full guide.",
    "common.appearsIn": "Appears in", "common.aliases": "Also known as", "common.viewSource": "View source",
    "common.askAi": "Ask AI about this", "common.facts": "Structured facts", "common.back": "Back",
    "common.results": "results", "common.result": "result", "common.noResults": "No results found. Try a different search.",
    "common.loading": "Loading…", "common.retry": "Retry", "common.networkError": "Something went wrong. Please try again.",
    "common.filterBySource": "Filter by guide", "common.all": "All", "common.showMore": "Show more",
  },
  fr: {
    "nav.strategist": "Stratège IA", "nav.generals": "Généraux", "nav.monsters": "Monstres",
    "nav.guides": "Guides", "nav.language": "Langue",
    "brand.tagline": "Votre compagnon de stratégie IA pour Evony",
    "brand.unofficial": "Compagnon non officiel pour Evony: The King's Return",
    "chat.intro": "Posez une question sur Evony ou touchez une suggestion ci-dessous :",
    "chat.placeholder": "Posez une question sur Evony…", "chat.searching": "Recherche dans le Wiki Guide Evony…",
    "chat.sources": "Sources", "chat.copy": "Copier", "chat.copied": "Copié",
    "chat.noReliableSource": "aucune source fiable", "chat.error": "Erreur",
    "generals.title": "Généraux d'Evony", "generals.subtitle": "Recherchez des généraux et voyez les guides où ils apparaissent, issus du Wiki Guide Evony.",
    "generals.search": "Rechercher un général par son nom…",
    "monsters.title": "Monstres et Boss d'Evony", "monsters.subtitle": "Parcourez les boss et monstres avec leur puissance, issus du Wiki Guide Evony.",
    "monsters.search": "Rechercher un monstre ou un boss…", "monsters.power": "Puissance", "monsters.level": "Niveau", "monsters.type": "Type",
    "guides.title": "Guides Evony", "guides.subtitle": "Découvrez des guides de stratégie pour généraux, boss, recherches et plus, dans votre langue.",
    "guides.search": "Rechercher des guides…", "guides.allCategories": "Toutes les catégories",
    "guides.availableIn": "Disponible en", "guides.contents": "Dans ce guide", "guides.openWiki": "Ouvrir sur le Wiki Guide Evony",
    "guides.contentNote": "Ceci est un résumé de découverte. Ouvrez la page Wiki originale pour le guide complet.",
    "common.appearsIn": "Apparaît dans", "common.aliases": "Aussi appelé", "common.viewSource": "Voir la source",
    "common.askAi": "Interroger l'IA à ce sujet", "common.facts": "Données structurées", "common.back": "Retour",
    "common.results": "résultats", "common.result": "résultat", "common.noResults": "Aucun résultat. Essayez une autre recherche.",
    "common.loading": "Chargement…", "common.retry": "Réessayer", "common.networkError": "Une erreur est survenue. Veuillez réessayer.",
    "common.filterBySource": "Filtrer par guide", "common.all": "Tout", "common.showMore": "Voir plus",
  },
  ja: {
    "nav.strategist": "AI ストラテジスト", "nav.generals": "将軍", "nav.monsters": "モンスター",
    "nav.guides": "ガイド", "nav.language": "言語",
    "brand.tagline": "Evony のための AI 戦略パートナー",
    "brand.unofficial": "Evony: The King's Return の非公式コンパニオン",
    "chat.intro": "Evony について質問するか、下の候補をタップしてください：",
    "chat.placeholder": "Evony について質問…", "chat.searching": "Evony ガイド Wiki を検索中…",
    "chat.sources": "出典", "chat.copy": "コピー", "chat.copied": "コピーしました",
    "chat.noReliableSource": "信頼できる出典なし", "chat.error": "エラー",
    "generals.title": "Evony の将軍", "generals.subtitle": "将軍を検索し、Evony ガイド Wiki に基づき登場するガイドを確認できます。",
    "generals.search": "将軍を名前で検索…",
    "monsters.title": "Evony のモンスターとボス", "monsters.subtitle": "Evony ガイド Wiki のパワー値でボスとモンスターを閲覧。",
    "monsters.search": "モンスターまたはボスを検索…", "monsters.power": "パワー", "monsters.level": "レベル", "monsters.type": "種類",
    "guides.title": "Evony ガイド", "guides.subtitle": "将軍・ボス・研究などの戦略ガイドをあなたの言語で。",
    "guides.search": "ガイドを検索…", "guides.allCategories": "すべてのカテゴリ",
    "guides.availableIn": "対応言語", "guides.contents": "このガイドの内容", "guides.openWiki": "Evony ガイド Wiki で開く",
    "guides.contentNote": "これは概要です。完全なガイドは元の Wiki ページをご覧ください。",
    "common.appearsIn": "登場箇所", "common.aliases": "別名", "common.viewSource": "出典を見る",
    "common.askAi": "これについて AI に質問", "common.facts": "構造化データ", "common.back": "戻る",
    "common.results": "件", "common.result": "件", "common.noResults": "結果が見つかりません。別の検索をお試しください。",
    "common.loading": "読み込み中…", "common.retry": "再試行", "common.networkError": "問題が発生しました。もう一度お試しください。",
    "common.filterBySource": "ガイドで絞り込む", "common.all": "すべて", "common.showMore": "もっと見る",
  },
  de: {
    "nav.strategist": "KI-Stratege", "nav.generals": "Generäle", "nav.monsters": "Monster",
    "nav.guides": "Guides", "nav.language": "Sprache",
    "brand.tagline": "Dein KI-Strategiebegleiter für Evony",
    "brand.unofficial": "Inoffizieller Begleiter für Evony: The King's Return",
    "chat.intro": "Stelle eine Frage zu Evony oder tippe unten einen Vorschlag an:",
    "chat.placeholder": "Frage zu Evony stellen…", "chat.searching": "Durchsuche das Evony-Guide-Wiki…",
    "chat.sources": "Quellen", "chat.copy": "Kopieren", "chat.copied": "Kopiert",
    "chat.noReliableSource": "keine zuverlässige Quelle", "chat.error": "Fehler",
    "generals.title": "Evony-Generäle", "generals.subtitle": "Suche Generäle und sieh die Guides, in denen sie erscheinen – aus dem Evony-Guide-Wiki.",
    "generals.search": "General nach Namen suchen…",
    "monsters.title": "Evony-Monster & Bosse", "monsters.subtitle": "Durchstöbere Bosse und Monster mit Stärkewerten aus dem Evony-Guide-Wiki.",
    "monsters.search": "Monster oder Boss suchen…", "monsters.power": "Stärke", "monsters.level": "Stufe", "monsters.type": "Typ",
    "guides.title": "Evony-Guides", "guides.subtitle": "Entdecke Strategie-Guides zu Generälen, Bossen, Forschung und mehr – in deiner Sprache.",
    "guides.search": "Guides suchen…", "guides.allCategories": "Alle Kategorien",
    "guides.availableIn": "Verfügbar in", "guides.contents": "In diesem Guide", "guides.openWiki": "Im Evony-Guide-Wiki öffnen",
    "guides.contentNote": "Dies ist eine Zusammenfassung. Öffne die Original-Wiki-Seite für den vollständigen Guide.",
    "common.appearsIn": "Erscheint in", "common.aliases": "Auch bekannt als", "common.viewSource": "Quelle ansehen",
    "common.askAi": "KI dazu fragen", "common.facts": "Strukturierte Daten", "common.back": "Zurück",
    "common.results": "Ergebnisse", "common.result": "Ergebnis", "common.noResults": "Keine Ergebnisse. Versuche eine andere Suche.",
    "common.loading": "Lädt…", "common.retry": "Erneut versuchen", "common.networkError": "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
    "common.filterBySource": "Nach Guide filtern", "common.all": "Alle", "common.showMore": "Mehr anzeigen",
  },
  es: {
    "nav.strategist": "Estratega IA", "nav.generals": "Generales", "nav.monsters": "Monstruos",
    "nav.guides": "Guías", "nav.language": "Idioma",
    "brand.tagline": "Tu compañero de estrategia con IA para Evony",
    "brand.unofficial": "Compañero no oficial para Evony: The King's Return",
    "chat.intro": "Haz una pregunta sobre Evony o toca una sugerencia abajo:",
    "chat.placeholder": "Pregunta sobre Evony…", "chat.searching": "Buscando en la Wiki Guía de Evony…",
    "chat.sources": "Fuentes", "chat.copy": "Copiar", "chat.copied": "Copiado",
    "chat.noReliableSource": "sin fuente fiable", "chat.error": "Error",
    "generals.title": "Generales de Evony", "generals.subtitle": "Busca generales y mira las guías donde aparecen, según la Wiki Guía de Evony.",
    "generals.search": "Buscar un general por su nombre…",
    "monsters.title": "Monstruos y Jefes de Evony", "monsters.subtitle": "Explora jefes y monstruos con valores de poder de la Wiki Guía de Evony.",
    "monsters.search": "Buscar un monstruo o jefe…", "monsters.power": "Poder", "monsters.level": "Nivel", "monsters.type": "Tipo",
    "guides.title": "Guías de Evony", "guides.subtitle": "Descubre guías de estrategia para generales, jefes, investigación y más, en tu idioma.",
    "guides.search": "Buscar guías…", "guides.allCategories": "Todas las categorías",
    "guides.availableIn": "Disponible en", "guides.contents": "En esta guía", "guides.openWiki": "Abrir en la Wiki Guía de Evony",
    "guides.contentNote": "Este es un resumen. Abre la página original de la Wiki para la guía completa.",
    "common.appearsIn": "Aparece en", "common.aliases": "También conocido como", "common.viewSource": "Ver fuente",
    "common.askAi": "Preguntar a la IA sobre esto", "common.facts": "Datos estructurados", "common.back": "Volver",
    "common.results": "resultados", "common.result": "resultado", "common.noResults": "Sin resultados. Prueba otra búsqueda.",
    "common.loading": "Cargando…", "common.retry": "Reintentar", "common.networkError": "Algo salió mal. Inténtalo de nuevo.",
    "common.filterBySource": "Filtrar por guía", "common.all": "Todo", "common.showMore": "Ver más",
  },
  ko: {
    "nav.strategist": "AI 전략가", "nav.generals": "장군", "nav.monsters": "몬스터",
    "nav.guides": "가이드", "nav.language": "언어",
    "brand.tagline": "Evony를 위한 AI 전략 파트너",
    "brand.unofficial": "Evony: The King's Return 비공식 컴패니언",
    "chat.intro": "Evony에 대해 질문하거나 아래 추천을 탭하세요:",
    "chat.placeholder": "Evony에 대해 질문하세요…", "chat.searching": "Evony 가이드 위키 검색 중…",
    "chat.sources": "출처", "chat.copy": "복사", "chat.copied": "복사됨",
    "chat.noReliableSource": "신뢰할 수 있는 출처 없음", "chat.error": "오류",
    "generals.title": "Evony 장군", "generals.subtitle": "장군을 검색하고 Evony 가이드 위키 기준으로 등장하는 가이드를 확인하세요.",
    "generals.search": "이름으로 장군 검색…",
    "monsters.title": "Evony 몬스터 & 보스", "monsters.subtitle": "Evony 가이드 위키의 전투력 값으로 보스와 몬스터를 둘러보세요.",
    "monsters.search": "몬스터 또는 보스 검색…", "monsters.power": "전투력", "monsters.level": "레벨", "monsters.type": "종류",
    "guides.title": "Evony 가이드", "guides.subtitle": "장군, 보스, 연구 등 전략 가이드를 당신의 언어로 만나보세요.",
    "guides.search": "가이드 검색…", "guides.allCategories": "모든 카테고리",
    "guides.availableIn": "지원 언어", "guides.contents": "이 가이드 내용", "guides.openWiki": "Evony 가이드 위키에서 열기",
    "guides.contentNote": "이것은 요약입니다. 전체 가이드는 원본 위키 페이지에서 확인하세요.",
    "common.appearsIn": "등장 위치", "common.aliases": "다른 이름", "common.viewSource": "출처 보기",
    "common.askAi": "이것에 대해 AI에게 질문", "common.facts": "구조화된 데이터", "common.back": "뒤로",
    "common.results": "개 결과", "common.result": "개 결과", "common.noResults": "결과가 없습니다. 다른 검색을 시도하세요.",
    "common.loading": "로딩 중…", "common.retry": "다시 시도", "common.networkError": "문제가 발생했습니다. 다시 시도해 주세요.",
    "common.filterBySource": "가이드로 필터링", "common.all": "전체", "common.showMore": "더 보기",
  },
  ar: {
    "nav.strategist": "المستشار الذكي", "nav.generals": "الجنرالات", "nav.monsters": "الوحوش",
    "nav.guides": "الأدلة", "nav.language": "اللغة",
    "brand.tagline": "رفيقك الاستراتيجي بالذكاء الاصطناعي للعبة Evony",
    "brand.unofficial": "رفيق غير رسمي للعبة Evony: The King's Return",
    "chat.intro": "اطرح سؤالاً عن Evony أو اضغط على اقتراح بالأسفل:",
    "chat.placeholder": "اطرح سؤالاً عن Evony…", "chat.searching": "جارٍ البحث في ويكي دليل Evony…",
    "chat.sources": "المصادر", "chat.copy": "نسخ", "chat.copied": "تم النسخ",
    "chat.noReliableSource": "لا يوجد مصدر موثوق", "chat.error": "خطأ",
    "generals.title": "جنرالات Evony", "generals.subtitle": "ابحث عن الجنرالات وشاهد الأدلة التي يظهرون فيها، من ويكي دليل Evony.",
    "generals.search": "ابحث عن جنرال بالاسم…",
    "monsters.title": "وحوش وزعماء Evony", "monsters.subtitle": "تصفّح الزعماء والوحوش مع قيم القوة من ويكي دليل Evony.",
    "monsters.search": "ابحث عن وحش أو زعيم…", "monsters.power": "القوة", "monsters.level": "المستوى", "monsters.type": "النوع",
    "guides.title": "أدلة Evony", "guides.subtitle": "اكتشف أدلة الاستراتيجية للجنرالات والزعماء والبحث والمزيد بلغتك.",
    "guides.search": "ابحث في الأدلة…", "guides.allCategories": "كل الفئات",
    "guides.availableIn": "متوفر بـ", "guides.contents": "في هذا الدليل", "guides.openWiki": "افتح في ويكي دليل Evony",
    "guides.contentNote": "هذا ملخّص للاكتشاف. افتح صفحة الويكي الأصلية للدليل الكامل.",
    "common.appearsIn": "يظهر في", "common.aliases": "يُعرف أيضاً بـ", "common.viewSource": "عرض المصدر",
    "common.askAi": "اسأل الذكاء الاصطناعي عن هذا", "common.facts": "بيانات منظمة", "common.back": "رجوع",
    "common.results": "نتيجة", "common.result": "نتيجة", "common.noResults": "لا توجد نتائج. جرّب بحثاً آخر.",
    "common.loading": "جارٍ التحميل…", "common.retry": "إعادة المحاولة", "common.networkError": "حدث خطأ ما. حاول مرة أخرى.",
    "common.filterBySource": "تصفية حسب الدليل", "common.all": "الكل", "common.showMore": "عرض المزيد",
  },
  pt: {
    "nav.strategist": "Estrategista IA", "nav.generals": "Generais", "nav.monsters": "Monstros",
    "nav.guides": "Guias", "nav.language": "Idioma",
    "brand.tagline": "Seu companheiro de estratégia com IA para Evony",
    "brand.unofficial": "Companheiro não oficial para Evony: The King's Return",
    "chat.intro": "Faça uma pergunta sobre Evony ou toque em uma sugestão abaixo:",
    "chat.placeholder": "Faça uma pergunta sobre Evony…", "chat.searching": "Pesquisando no Wiki Guia do Evony…",
    "chat.sources": "Fontes", "chat.copy": "Copiar", "chat.copied": "Copiado",
    "chat.noReliableSource": "sem fonte confiável", "chat.error": "Erro",
    "generals.title": "Generais do Evony", "generals.subtitle": "Pesquise generais e veja os guias onde aparecem, do Wiki Guia do Evony.",
    "generals.search": "Pesquisar um general pelo nome…",
    "monsters.title": "Monstros e Chefes do Evony", "monsters.subtitle": "Explore chefes e monstros com valores de poder do Wiki Guia do Evony.",
    "monsters.search": "Pesquisar um monstro ou chefe…", "monsters.power": "Poder", "monsters.level": "Nível", "monsters.type": "Tipo",
    "guides.title": "Guias do Evony", "guides.subtitle": "Descubra guias de estratégia para generais, chefes, pesquisa e mais, no seu idioma.",
    "guides.search": "Pesquisar guias…", "guides.allCategories": "Todas as categorias",
    "guides.availableIn": "Disponível em", "guides.contents": "Neste guia", "guides.openWiki": "Abrir no Wiki Guia do Evony",
    "guides.contentNote": "Este é um resumo. Abra a página original do Wiki para o guia completo.",
    "common.appearsIn": "Aparece em", "common.aliases": "Também conhecido como", "common.viewSource": "Ver fonte",
    "common.askAi": "Perguntar à IA sobre isto", "common.facts": "Dados estruturados", "common.back": "Voltar",
    "common.results": "resultados", "common.result": "resultado", "common.noResults": "Nenhum resultado. Tente outra pesquisa.",
    "common.loading": "Carregando…", "common.retry": "Tentar novamente", "common.networkError": "Algo deu errado. Tente novamente.",
    "common.filterBySource": "Filtrar por guia", "common.all": "Tudo", "common.showMore": "Ver mais",
  },
};

export function t(lang, key) {
  const l = STR[lang] || STR.en;
  return l[key] ?? STR.en[key] ?? key;
}

export function suggestions(lang) {
  return SUGGESTIONS[lang] || SUGGESTIONS.en;
}
